import React from "react";
import "./App.css";
import SignUp from "./pages/signup";

function App() {
  return (
    <div>
      <SignUp />
    </div>
  );
}

export default App;
